import { apiClient } from './client';
export const formSubmissionsApi = {
    // Get reprocessable (transient) failed form submissions
    getReprocessableFailedSubmissions: (workspaceId) => apiClient.get(`/api/FormSubmissions/Failed/Reprocessable/${workspaceId}`),
    // Get non-reprocessable failed form submissions with optional date range
    getNonReprocessableFailedSubmissions: (workspaceId, sinceUtc) => {
        const queryParam = sinceUtc ? `?sinceUtc=${encodeURIComponent(sinceUtc)}` : '';
        return apiClient.get(`/api/FormSubmissions/Failed/NonReprocessable/${workspaceId}${queryParam}`);
    },
    // Retry failed form submissions
    retryFailedSubmissions: (workspaceId, formSubmissionIds) => {
        const payload = { FormSubmissionIds: formSubmissionIds };
        return apiClient.post(`/api/FormSubmissions/Retry/${workspaceId}`, payload);
    },
    // Delete failed form submissions
    deleteFailedSubmissions: (workspaceId, formSubmissionIds) => {
        const payload = { FormSubmissionIds: formSubmissionIds };
        return apiClient.delete(`/api/FormSubmissions/Failed/${workspaceId}`, { body: payload });
    },
    // Update payload for a failed form submission
    updateFailedSubmissionPayload: (workspaceId, submissionId, newPayloadJson) => {
        const payload = { PayloadJson: newPayloadJson };
        return apiClient.put(`/api/FormSubmissions/Failed/${workspaceId}/${submissionId}/Payload`, payload);
    }
};
